import { ElementSource } from "chq";

const sourceToSnakeCase = (obj: any): ElementSource => {
  if (!obj && obj !== 0 && obj !== false) return {};
  if (Array.isArray(obj)) return obj.map(item => sourceToSnakeCase(item));
  if (typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      const snakeKey = key.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
      acc[snakeKey] = sourceToSnakeCase(obj[key]);
      return acc;
    }, {} as Record<string, any>);
  }
  return obj;
};

export default sourceToSnakeCase;
